
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

@Component
export default class Toolbar extends Vue {
  @State('user') public user!: string
  @State('isLogged') public isLogged!: boolean

  @Prop() private readonly showNavbar!: () => void

  constructor() {
    super()
  }
}
